import { DView } from './DView'

/**
 * DPage - Main Drafter screen.
 *
 * Features a collapsible session sidebar on the left, chat in the center,
 * and document panel on the right. Starts by selecting a completed Foolscap.
 */
export function DPage() {
  return <DView />
}
